import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { WSIBClassRateSetup } from "../../components/WSIBClassRateSetup";

export const WSIBClassRateSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Class Rate Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Class Rate Setup", navigateTo: "#" }
      ]}
      mainContents={<WSIBClassRateSetup />}
    />
  );
};
